import { AutocompleteOption } from 'pages/common/components/Autocomplete/types';
import { options as funnelAnxietyOptions } from 'pages/funnel/components/Anxiety/constants';
import { options as funnelAttitudeOptions } from 'pages/funnel/components/Attitude/constants';
import { options as funnelGoalsOptions } from 'pages/funnel/components/Goals/constants';
import { options as funnelLastVisitedOptions } from 'pages/funnel/components/LastVisited/constants';
import { treatmentCheckupCleaning, treatments, urgentIssues } from 'pages/funnel/components/ReasonDetails/constants';
import { BooleanChoice } from 'types/BooleanChoice';

export const ATTITUDE_OPTIONS: AutocompleteOption[] = funnelAttitudeOptions.map((option) => ({
  id: option.id,
  name: option.title,
  description: option.description,
}));

export const GOALS_OPTIONS: AutocompleteOption[] = funnelGoalsOptions.map((option) => ({
  id: option.id,
  name: option.title,
}));

export const LAST_VISITED_OPTIONS: AutocompleteOption[] = funnelLastVisitedOptions.map((option) => ({
  id: option.id,
  name: option.title,
}));

export const ANXIETY_OPTIONS: AutocompleteOption[] = funnelAnxietyOptions.map((option) => ({
  id: option.id,
  name: option.title,
}));

export const URGENT_OPTIONS = [BooleanChoice.Yes, BooleanChoice.No];

const treatmentsOptions = [treatmentCheckupCleaning, ...treatments];
export const TREATMENTS_OPTIONS: AutocompleteOption[] = treatmentsOptions.map((option) => ({
  id: option.id,
  name: option.title,
}));

export const URGENT_DETAILS_OPTIONS: AutocompleteOption[] = urgentIssues.map((option) => ({
  id: option.id,
  name: option.title,
}));
